import { render, staticRenderFns } from "./MuBiao.vue?vue&type=template&id=47673a35&scoped=true&"
import script from "./MuBiao.vue?vue&type=script&lang=js&"
export * from "./MuBiao.vue?vue&type=script&lang=js&"
import style0 from "./MuBiao.vue?vue&type=style&index=0&id=47673a35&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47673a35",
  null
  
)

export default component.exports